<template>
  <div id="app">
		<headBox />
		<router-view :key="$route.fullPath"></router-view>
		<footBox />
  </div>
</template>

<script>
import headBox from './components/head-box.vue'
import footBox from './components/foot-box.vue'
export default {
  name: 'app',
  components: {
		headBox,
		footBox
  }
}
</script>

<style>
body{
	margin: 0;
	font-size: 1vw; /* 假设你想要在PC端网页中的字体大小是手机端的两倍 */
}
#app {
	width: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 3.5rem;
	overflow: hidden;
}
div::-webkit-scrollbar-thumb{
	background-color:rgba(0,0,0,.05);
	border-radius:.6rem;
	-webkit-box-shadow:inset1px1px0rgba(0,0,0,.1);
}
div::-webkit-scrollbar-track{
	border-radius:.6rem;
	-webkit-box-shadow:inset006pxrgba(0,0,0,0);
	background-color:white;
}
img{
	width: 100%;
	margin: 0;
	padding: 0;
}
input{
	border: none;
}
input[type=text]:focus {
	outline: none;
}
.s-img{
	position: relative;
}
.disappearText{
	display: none;
}
.s-desc-text{
	padding-left: 12%;
	font-size: 4rem;
	text-align: left;
	color: red;
}
@media screen and (max-width:750px) {
	.s-desc-text{
		font-size: 1rem;
	}
}
</style>
